// src/pages/CaseDetailPage.jsx
import { useParams, Navigate } from 'react-router-dom';
import { getCaseBySlug } from '../data/cases';
import { DetailPageTemplate } from '../components/templates/DetailPageTemplate';
import { Seo } from '../components/Seo';
import { articleJsonLd, breadcrumbJsonLd } from '../lib/structuredData';

export function CaseDetailPage() {
  const { slug } = useParams();
  const caseItem = getCaseBySlug(slug);

  if (!caseItem) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Seo
        title={`${caseItem.title} — medilawyer`}
        description={caseItem.summary}
        path={`/cases/${caseItem.slug}`}
        jsonLd={[
          articleJsonLd({
            title: caseItem.title,
            description: caseItem.summary,
            path: `/cases/${caseItem.slug}`,
          }),
          breadcrumbJsonLd([
            { name: '홈', path: '/' },
            { name: '사례', path: '/#strengths' },
            { name: caseItem.title, path: `/cases/${caseItem.slug}` },
          ]),
        ]}
      />
      <DetailPageTemplate
        eyebrow="Case"
        title={caseItem.title}
        intro={caseItem.summary}
        sections={[
          {
            heading: '상세 콘텐츠 준비 중',
            body: '이 사례의 상세 내용은 현재 정리 중입니다. 유사 사례 상담이 필요하시면 아래 폼으로 문의 주세요.',
          },
        ]}
        ctaLabel="유사 사례 상담 요청"
        serviceContext={`case:${caseItem.slug}`}
        backHref="/#strengths"
      />
    </>
  );
}
